import React, { Component } from 'react';
import './adminDash.css';
import withNavigate from '../Global_files/WithNavigate'; // Import the custom HOC// import globalVariables from "../global_files/globalVariables";
import { post, get } from '../custom_libraries/serverRequests';
// import { displayDateTime, isEmpty } from '../global_files/validation';
import globalVariables from "../custom_libraries/globalVariables";
// import { useNavigate } from "react-router-dom";
import urls from '../custom_libraries/urls';
import passwordEye from '../assets/icons8-eye-64.png';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import Backdrop from '@mui/material/Backdrop';
// import WebLogo from '../assets/circular-CHM-logo.png';
import WebLogo from '../assets/Artboard 1Bonus.png'; //updated logo
// import WebLogo from '../assets/Artboard 1Bonus2-modified.png'; 

class signIn extends Component {
    constructor(props) {
      super(props);
      this.state = {
        username: '',
        password: '',
        day:'',
        date:'',
        month:'',
        year:'',

        showDialog: false,
        showPasscodeForm: false,
        input_email_for_password_reset:'',
        userName_for_newPassword:'',
        received_passcode:'',
        new_password:'',
        confirm_password:'',
        email_for_save_new_pass:'',
        passwordShown:false,

        warning: false,
        success: false,
        error:false,
        warning1: false,
        open_progress_bar: false,
        site_list:[],

      };
    }

    componentDidUpdate(prevProps, prevState) {
      if (
          this.state.warning !== prevState.warning ||
          this.state.error !== prevState.error ||
          this.state.warning1 !== prevState.warning1
      ) {
          if (
              this.state.warning ||
              this.state.error ||
              this.state.warning1
          ) {
              setTimeout(() => {
                  this.setState({
                      warning: false,
                      error: false,
                      warning1: false,
                  });
              }, 3000); // 3 second
          }
      }
  }
  
    // Event handler for the username input field
    handleUsernameChange = (event) => {
      this.setState({ username: event.target.value });
    };
  
    // Event handler for the password input field
    handlePasswordChange = (event) => {
      this.setState({ password: event.target.value });
    };

    handleEmailChange = (event) => {
      this.setState({ email: event.target.value });
    };

    handlePasscodeChange = (event) => {
      this.setState({ email_passcode: event.target.value });
    };

isEmptyFields = () => {
  let data = [
      // this.state.ip_address,
      this.state.username,
      this.state.password
  ]
  // return isEmpty(data)
}

jsonDataForVerify = () => {
  let data = {
      "username": this.state.username.trim(),
      "password": this.state.password.trim(),
      "email": this.state.email.trim(),
      "email_passcode": this.state.email_passcode.trim()
  }
  localStorage.setItem(globalVariables.USER_NAME, this.state.username);
  localStorage.setItem(globalVariables.USER_PASSWORD, this.state.password);
  return JSON.stringify(data)
}

jsonData = () => {
  let data = {
      "username": this.state.username.trim(),
      "password": this.state.password.trim()
      
  }
  localStorage.setItem(globalVariables.USER_NAME, this.state.username);
  localStorage.setItem(globalVariables.USER_PASSWORD, this.state.password);

  return JSON.stringify(data)
}


userLogin = async (event) => {
  event.preventDefault(); // Prevent form default behavior, if applicable
  console.log("Starting userLogin function...");
  const {username, password} = this.state
  // Check if all required fields are filled
  if (username  === "" || password === "") {
    this.setState({ warning: true});
    console.log("Validation failed: Some fields are empty.");
    return;
  }

  console.log("All required fields are filled.");

  // Start loading indicator
  this.startLoading();
  console.log("Loading started...");

      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          // 'content-type': 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${access_tocken}`
      }
  try {
    let data = null;

    // First-time login logic
    if (this.state.firstTimeLogin === true) {
      console.log("First-time login detected. Preparing to verify email and passcode...");
      
      let postdata = this.jsonDataForVerify(); // Get email verification data
      console.log("Verification payload:", postdata);

      data = await post(urls.VERIFY_EMAIL, postdata, headers);
      
      console.log("Email verification response:", data);
      // detail: "No active account found with the given credentials"
      if (data === false) {
        console.error("Error while verifying email passcode!");
        alert("Failed to verify email and passcode. Please check your details.");
        this.stopLoading();
        console.log("Loading stopped due to verification failure.");
        return;
      }
      console.log("Email verified successfully.");
    } else {
      // Regular login logic
      console.log("Regular login detected. Preparing to log in...");
      
      let post_data = this.jsonData(); // Get login data
      console.log("Login payload:", post_data);

      data = await post(urls.LOGIN, post_data, headers);

      console.log("Login response:", data);

      if (data.data.error === false) {
        console.error("Login failed. Server returned false.");
        // alert("Something went wrong with the server or please check your login details!");
        this.stopLoading();
        this.setState({ error: true});
        console.log("Loading stopped due to login failure.");
        return;
      }
      if(data.data.error === "No active account found with the given credentials"){
        // alert ("check your credentials");
        this.stopLoading();
        this.setState({warning1: true});
      }
      if(data.data.error === "User not found."){
        // alert ("check your credentials");
        this.stopLoading();
        this.setState({warning1: true});
      }

    }

    // Process successful login response
    if (data.data && Array.isArray(data.data) && data.data.length > 0) {
      console.log("Processing login response...");
      const userData = data.data[0]; // Extract the first object from the array

      console.log("Access Token:", userData.access);
      console.log("Refresh Token:", userData.refresh);
      console.log("User ID:", userData.user_id);

      localStorage.setItem(globalVariables.AUTH_TOKEN, userData.access);
      localStorage.setItem(globalVariables.REFRESH_TOKEN, userData.refresh);
      localStorage.setItem(globalVariables.TOKEN_EXPIRY, this.expiryTime(12))
      localStorage.setItem(globalVariables.USER_ID, userData.user_id);

      localStorage.setItem(globalVariables.USER_TYPE, userData.user_type)

      if (userData.user_type === "DealerUser") {
          console.log("User is a DealerUser. Navigating to /system-overview...");
          console.log("Login successful.");
          this.stopLoading();
          this.setState({success: true});
          
          //based on site data is available or not for this dealer/admin, following is the condition to check whether the user should be redirected to client-portal or system-overview
          this.getSitesList().then((siteList) => {                
            if (siteList === null || siteList.length === 0) {
              localStorage.setItem(globalVariables.USER_ID, userData.user_id);
              // console.log("---- this.props.navigate(/client-portal)----", siteList);
              setTimeout(() => {
                this.props.navigate("/showDevices"); // Delay before navigation to allow user to see the alert
              }, 700); // 700 mili seconds delay
            } else {
              // console.log("---- this.props.navigate(/system-overview)----", siteList);
              setTimeout(() => {
                this.props.navigate("/system-overview");
              }, 700); // 700 mili seconds delay
            }
          });

      } else if (userData.user_type === "TechnicianUser"){
          console.log("User is a TechnicianUser. Navigating to /system-overview...");
          console.log("Login successful.");
          this.stopLoading();
          this.setState({success: true});
          //based on site data is available or not for this technician, following is the condition to check whether the user should be redirected to client-portal or system-overview

          this.getSitesList().then((siteList) => {                
            if (siteList === null || siteList.length === 0) {
              localStorage.setItem(globalVariables.USER_ID, userData.user_id);
              // console.log("---- this.props.navigate(/client-portal)----", siteList);
              setTimeout(() => {
                this.getAssociatedDealerID(userData.user_id);
                this.props.navigate("/showDevices");
              }, 700); // 2 seconds delay
            } else {
              // console.log("---- this.props.navigate(/system-overview)----", siteList);
              setTimeout(() => {
                this.getAssociatedDealerID(userData.user_id)
                this.props.navigate("/system-overview");
              }, 700); // 2 seconds delay
            }
          });
      }else if (userData.user_type === "CustomerUser"){
        console.log("User is a TechnicianUser. Navigating to /system-overview...");
        console.log("Login successful.");
        this.stopLoading();
        this.setState({success: true});
        // console.log("---- this.props.navigate(/system-overview)----", siteList);
            setTimeout(() => {
              this.getAssociatedDealerID(userData.user_id)
              this.props.navigate("/system-overview");
            }, 700); // 2 seconds delay
          
        
    }
      else {
        console.log("User type is not registered. No navigation performed.");
        this.setState({warning1: true});
      }
    } else {
      console.error("Something went wrong. Data is false.");
      this.stopLoading();
      // alert("Something went wrong with the server or please check your login details!");
      this.setState({ error: true});
    }
  } catch (error) {
    console.error("Error during login process:", error);
    // alert("An unexpected error occurred. Please try again.");
    this.setState({ error: true});
  } finally {
    // Stop loading indicator
    this.stopLoading();
    console.log("Loading stopped. Exiting userLogin function...");
  }
};

getSitesList = async () => {
  try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      console.log("Fetching data from:", urls.GET_SITES_BY_USER); // Update URL for fetching sites
      const response = await get(urls.GET_SITES_BY_USER, headers);
      console.log("response===> ", response);

      if (!response.data) {
          console.error("Failed to fetch site list.");
          this.setState({ site_list: [] });
          return [];
      }

      this.setState({ site_list: response.data });
      return response.data;
  } catch (error) {
      console.error("Error in getSitesList:", error);
      this.setState({ site_list: [] });
      return [];
  }
};

getAssociatedDealerID = async (userId) =>{

 let response = await get(urls.ASSOCIATED_DEALER_UUID(userId))

 console.log("dealer uuid-----", response);
 localStorage.setItem(globalVariables.DEALER_UUID, response.dealer_uuid);
}

expiryTime = (hour) => {
  let now = new Date();
  now.setHours(now.getHours() + hour);
  return now
}

keyPress = (evt) => {
  if (evt.key === "Enter") {
      this.userLogin()
  }
}

startLoading = () => {
  this.setState({ open_progress_bar: true })
}

stopLoading = () => {
  this.setState({ open_progress_bar: false })
}


handleSignUpClick =() =>{
  this.props.navigate("/new_dealer_registration");
}

toggleFirstTimeLogin = () => {
  this.setState((prevState) => ({
    firstTimeLogin: !prevState.firstTimeLogin,
    email: "", // Reset email
    email_passcode: "", // Reset email_passcode
  }));
}

/**********************forgot password section*********** */
  handleForgotPasswordClick = () => {
  this.setState({ showDialog: true });
  };

  handleCheckboxChange = (e) => {
  this.setState({ showPasscodeForm: e.target.checked });
  };

  handleCloseDialog = () => {
    this.setState({ showDialog: false, showPasscodeForm: false });
  };

  sendMail = async () => {
    this.startLoading();
    let data = {
      "email": this.state.input_email_for_password_reset    
    }
    // return JSON.stringify(data)
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
    let headers = {
      'content-Type': 'application/json; charset=UTF-8',
      'Authorization': `Bearer ${access_tocken}`
    }
    let post_data = JSON.stringify(data);

    console.log("--------------------sendMail for login reset--------------",post_data);
    let response = await post(urls.RESET_PASSWORD, post_data, headers)
    console.log("--------------------user login--------------",response);
    this.stopLoading();
    if(response.detail==="Password reset e-mail has been sent."){
    alert("Password reset e-mail has been sent");
    }
    if(response === false){
      alert("The email you have entered is not registered with us!");
    }

  }

  SaveNewPassword = async () => {
    this.startLoading();
    let data = {
      // "email": this.state.email_for_save_new_pass  ,
      "new_password1": this.state.new_password,
      "new_password2": this.state.confirm_password,
      "uid": this.state.userName_for_newPassword,
      "token": this.state.received_passcode,
      }
      // return JSON.stringify(data)
      let post_data = JSON.stringify(data);
      
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      let headers = {
        'content-Type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${access_tocken}`
      }

      console.log("--------------------sendMail for login reset--------------",post_data);
      let response = await post(urls.RESET_PASSWORD_CONFIRM, post_data, headers)
      console.log("--------------------user login--------------",response);
      this.startLoading();
      if(response.detail==="Password has been reset with the new password."){
      alert("Your password is successfully reset with the new password!");
      window.location.reload();
      }
      else if(response.new_password2?.includes("The two password fields didn't match.")){
        alert("The two password fields didn't match.");
        // window.location.reload();
        }
      else if(response.passcode?.includes("Invalid value")){
          alert("The passcode you have entered is incorrect.");
          // window.location.reload();
          }
      else {
            alert("Something went wrong with the server, try again!");
          }
  }

  togglePasswordVisiblity = () => {
  this.setState(prevState => ({
    passwordShown: !prevState.passwordShown
  }));
  };
    
render() {
  const d = new Date()
    const weekday = ['Sun','Mon', 'Tues', 'Wed','Thurs', 'Fri', 'Sat']
    const months = ['Jan', 'Feb', 'March', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
  const day = weekday[(d.getDay())]
    const month = months[(d.getMonth())]
    const date = d.getDate()
    const year = d.getFullYear()
    const { showDialog, showPasscodeForm, passwordShown, warning, success, error,warning1 } = this.state;




  return (
    <div class="container">
      <div class="forms-container">
        <div class="signin-signup">
          <form action="#" class="sign-in-form">
          {warning ? (
                      <Alert severity="warning"> Please fill all the required details.</Alert>
                  ) : error ? (
                      <Alert severity="error">Something went wrong with server, try again! </Alert>
                  ) : success ? (
                      <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                          "Login successful!"
                      </Alert>
                  ) : warning1 ? (
                    <Alert severity="warning">
                        "Please enter valid credentials!"
                    </Alert>
                ): null}
            <img src={WebLogo} alt='web-logo' width='95px' 
            style={{backgroundColor:'#2d4d85', borderRadius:'100px'}} 
            />
            <h2 class="title">Sign in</h2>
              <div>
                <input type="text" className="name" id="signIn" placeholder="user name"  onChange={this.handleUsernameChange} />
              </div>
              <div className="second-input">
                <input type={passwordShown ? "text" : "password"} className="name" id="signIn" placeholder="password"  onChange={this.handlePasswordChange} />
                <img onClick={this.togglePasswordVisiblity} src={passwordEye} alt="password-eye" width='25' height='25' className="eye-icon"/>{" "}

              </div>
              <div style={{paddingTop:'10px'}}>
                <label style={{fontSize:'medium'}}>
                  First Time Login ? :</label>
                  <input
                    // className="name" id="signIn"
                    type="checkbox"
                    checked={this.state.firstTimeLogin}
                    onChange={this.toggleFirstTimeLogin}
                  />
              </div>
              {this.state.firstTimeLogin && (
                <>
                  <div class="sign-in-form" style={{paddingTop:'10px'}}>
                      <input
                        type="email"
                        name="email"
                        className="name" 
                        id="signIn"
                        placeholder="Email"
                        value={this.state.email}
                        onChange={this.handleEmailChange}
                        required={this.state.firstTimeLogin}
                      />
                  </div>
                  <div className="second-input">
                      <input
                        type="text"
                        name="email_passcode"
                        className="name"
                        id="signIn"
                        placeholder="Passcode recieved on email"
                        value={this.state.email_passcode}
                        onChange={this.handlePasscodeChange}
                        required={this.state.firstTimeLogin}
                      />
                  </div>
              </>
              )}
              <div className="login-button">
                <button 
                id='login'
                onClick={this.userLogin}
                >Login</button>
              </div>
              <div className="link">
                <a href="#" onClick={this.handleForgotPasswordClick}>Forgot password?</a> &nbsp;
                <a href="/delete_account" style={{color: "red"}}>Delete account?</a>
              </div>

              <div>
                <button 
                  id='SignUpButton'
                  onClick={this.handleSignUpClick}
                >
                  Sign Up
                </button>
              </div>
          </form>
        </div>
      </div>
      {showDialog && (
          <div className="overlay">
            <div className="dialog-reset-password">
              {!showPasscodeForm ? (
                <div>
                  <h2>Reset Password</h2>
                  <input 
                  type="email" 
                  placeholder="Enter your email" 
                  value={this.state.input_email_for_password_reset}
                  onChange={(evt) => this.setState({ input_email_for_password_reset: evt.target.value })}
                  required />
                  <button className="send-reset-pass-mail" onClick={this.sendMail}>Send</button>
                  <div className="received-passcode">
                  <label htmlFor="received-passcode">Received passcode?</label>
                    <input 
                      type="checkbox" 
                      id="received-passcode" 
                      onChange={this.handleCheckboxChange} 
                    />
                    
                  </div>
                  <button className="back" onClick={this.handleCloseDialog}>Back</button>
                </div>
              ) : (
                <div>
                  <h2>Set New Password</h2>
                  <input type="text" placeholder="Username" value={this.state.userName_for_newPassword} onChange={(evt) => this.setState({ userName_for_newPassword: evt.target.value })} required />
                  <input type="text" placeholder="Received Passcode" value={this.state.received_passcode} onChange={(evt) => this.setState({ received_passcode: evt.target.value })} required />
                  <input type="password" placeholder="New Password" value={this.state.new_password} onChange={(evt) => this.setState({ new_password: evt.target.value })} required />
                  <input type="password" placeholder="Confirm Password" value={this.state.confirm_password} onChange={(evt) => this.setState({ confirm_password: evt.target.value })} required />
                  {/* <input type="email" placeholder="Email" value={this.state.email_for_save_new_pass} onChange={(evt) => this.setState({ email_for_save_new_pass: evt.target.value })} required /> */}
                  <button className="send-reset-pass-mail" onClick={this.SaveNewPassword}>Save</button>
                  <div className='received-passcode'>
                  <label htmlFor="received-passcode">Received passcode?</label>
                    <input 
                      type="checkbox" 
                      id="received-passcode" 
                      checked={showPasscodeForm}
                      onChange={this.handleCheckboxChange} 
                    />
                    
                  </div>
                  <button className="back" onClick={this.handleCloseDialog}>Back</button>
                </div>
              )}
            </div>
          </div>
        )}

      <div class="panels-container">
        <div class="panel left-panel">
            <div className="date">
                <h2> {day} </h2>
                <h2> {date} </h2>
                <h2> {month} </h2>
                <h2> {year} </h2>
            </div>
            <div class="content">
              <h3>Welcome Admin !</h3>
              <p>
                Enter your details and start the journey with us.
              </p>
              {/* <button class="btn transparent" id="sign-up-btn">
                Sign up
              </button> */}
            
            </div>
          
        </div>
        
      </div>
      {/* Backdrop with CHM logo Progress */}
      <Backdrop className='backdrop' open={this.state.open_progress_bar}>
                <div className="custom-spinner">
                  <div className="circle"></div>
                  <div className="circle tilted"></div>
                  <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#2d4d85', borderRadius:'100px'}}/>
                </div>
      </Backdrop>
  </div>
    
  );
}
}

export default withNavigate(signIn);
